import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTimeout } from "../hooks";
import { Theme } from "../theme";
import { InformationIcon, CircleCheckIcon, AlertIcon } from "./icons";
import PropTypes from "prop-types";

const Container = styled.div`
    width: 100%;
`;

const Notification = styled.div`
    display: flex;
    align-items: center;
    padding-left: 16px;
    padding-right: 10px;
    margin: auto;
    width: 100%;
    min-height: 50px;
    background-color: ${(props) => {
        if (props.success) {
            return "#e4f1e9";
        }
        if (props.error) {
            return "#F4E3DB";
        }
        return "#e4f1e9";
    }};
    line-height: normal;
    border-left: 16px solid
        ${(props) => {
            if (props.success) {
                return Theme.colors.green;
            }
            if (props.error) {
                return Theme.colors.red;
            }
            return Theme.colors.green;
        }};
`;

export const InfoNotification = ({ show, onHide, success, error, alert, message, showDuration, forCsvValidate }) => {
    const timeout = useTimeout();

    useEffect(() => {
        clearTimeout(timeout.current);
        if (show) {
            timeout.current = setTimeout(onHide, showDuration ?? 3000);
        }

        return () => {
            clearTimeout(timeout.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    if (!show) return null;
    return (
        <Container>
            <Notification success={success} error={error}>
                {forCsvValidate ? (
                    success ? (
                        <CircleCheckIcon fill={Theme.colors.green} />
                    ) : (
                        <AlertIcon fill={Theme.colors.red} />
                    )
                ) : (
                    <InformationIcon />
                )}
                &emsp;
                <span>
                    {success && <strong>Success!&nbsp;</strong>}
                    {error && !success && <strong>Error!&nbsp;</strong>}
                    {alert && !success && <strong>Alert!&nbsp;</strong>}
                    {message}
                </span>
            </Notification>
        </Container>
    );
};

export const useNotification = (props) => {
    const [showNotifcation, setShowNotification] = useState(false);
    const [message, setMessage] = useState("");
    const [type, setType] = useState((props && props.type) ?? "success");

    const show = () => {
        setShowNotification(true);
    };

    const hide = () => {
        setShowNotification(false);
    };

    return {
        show,
        hide,
        message,
        setMessage,
        type,
        setType,
        renderNotification: () => {
            return (
                <InfoNotification
                    success={type === "success"}
                    error={type === "error"}
                    show={showNotifcation}
                    message={message}
                    timeout={props && props.timeout}
                    onHide={() => setShowNotification(false)}
                />
            );
        },
    };
};

InfoNotification.propTypes = {
    /*
        Was the user's request/action successfully completed?
    */
    success: PropTypes.string,
    /*
        Was there an error when attempting to do the user's request/action?
    */
    error: PropTypes.string,
};
